import { BarChart, Bar, LineChart, Line, AreaChart, Area, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer, Legend } from "recharts";
import { FONTS, COLORS } from "../constants/theme";

// ─── CompetitiveIQ ───────────────────────────────────────────────────────────────────
// Persona: Strategy / Product
// Data sources: See constants/modules.js

const KPIs = [
  { label: "Overall Win Rate", value: "62.7%", delta: "+4pts QoQ", color: "#059669" },
  { label: "vs Competitor A", value: "41%", delta: "-2pts QoQ", color: "#e11d48" },
  { label: "vs Competitor B", value: "78%", delta: "+6pts", color: "#059669" },
  { label: "vs Competitor C", value: "71%", delta: "+3pts", color: "#059669" },
  { label: "Competitive Deals", value: "38%", delta: "of all deals", color: "#d97706" },
  { label: "Displacement Rate", value: "18%", delta: "Comp → us", color: "#059669" }
];
const CHART_DATA = [
  {
    "quarter": "Q3 '25",
    "CompA": 44,
    "CompB": 71,
    "CompC": 68
  },
  {
    "quarter": "Q4 '25",
    "CompA": 43,
    "CompB": 73,
    "CompC": 69
  },
  {
    "quarter": "Q1 '26",
    "CompA": 43,
    "CompB": 75,
    "CompC": 70
  },
  {
    "quarter": "Q2 '26",
    "CompA": 41,
    "CompB": 78,
    "CompC": 71
  }
];

export default function CompetitiveIQ({ module: mod, theme }) {
  const { surface, border, text, muted, dark } = theme;

  return (
    <div style={{ display: "flex", flexDirection: "column", gap: 16 }}>

      {/* KPI Grid */}
      <div style={{ display: "grid", gridTemplateColumns: "repeat(3, 1fr)", gap: 12 }}>
        {KPIs.map((k, i) => (
          <div key={i} style={{ background: surface, border: `1px solid ${border}`, borderRadius: 12, padding: "16px 18px", position: "relative", overflow: "hidden" }}>
            <div style={{ position: "absolute", top: 0, left: 0, right: 0, height: 2, background: `linear-gradient(90deg, ${mod.accent}55, ${mod.accent})` }} />
            <p style={{ color: muted, fontSize: 10, fontFamily: FONTS.mono, letterSpacing: ".08em", textTransform: "uppercase", marginBottom: 6 }}>{k.label}</p>
            <p style={{ fontFamily: FONTS.display, fontWeight: 800, fontSize: 22, color: text, letterSpacing: "-.02em" }}>{k.value}</p>
            <span style={{ display: "inline-block", marginTop: 6, fontFamily: FONTS.mono, fontSize: 10, padding: "2px 7px", borderRadius: 20, color: k.color, background: k.color + "18" }}>{k.delta}</span>
          </div>
        ))}
      </div>

      {/* Chart */}
      <div style={{ background: surface, border: `1px solid ${border}`, borderRadius: 14, padding: "20px 24px" }}>
        <p style={{ fontFamily: FONTS.mono, fontSize: 11, color: muted, letterSpacing: ".08em", textTransform: "uppercase", marginBottom: 16 }}>Win Rate by Competitor Over Time</p>
        <ResponsiveContainer width="100%" height={240}>
          <LineChart data={CHART_DATA}>
          <CartesianGrid strokeDasharray="3 3" stroke="#1e243860" />
          <XAxis dataKey="quarter" tick={{ fill: "#8892b0", fontSize: 11 }} />
          <YAxis tick={{ fill: "#8892b0", fontSize: 11 }} />
          <Tooltip contentStyle={{ background: "#0a0e1a", border: "1px solid #1e2438", borderRadius: 8, fontSize: 11 }} />
          <Legend wrapperStyle={{ fontSize: 11, color: "#8892b0" }} />
          <Line type="monotone" dataKey="CompA" stroke="#e11d48" strokeWidth={2} dot={{r:3}} />
          <Line type="monotone" dataKey="CompB" stroke="#059669" strokeWidth={2} dot={{r:3}} />
          <Line type="monotone" dataKey="CompC" stroke="#d97706" strokeWidth={2} dot={{r:3}} />
        </LineChart>
        </ResponsiveContainer>
      </div>

      {/* Insight */}
      <div style={{ background: mod.accent + "10", border: `1px solid ${mod.accent}25`, borderRadius: 12, padding: "14px 18px", display: "flex", gap: 12, alignItems: "flex-start" }}>
        <span style={{ color: mod.accent, fontSize: 16, flexShrink: 0, marginTop: 1 }}>◉</span>
        <div>
          <p style={{ fontFamily: FONTS.mono, fontSize: 10, color: mod.accent, letterSpacing: ".08em", textTransform: "uppercase", marginBottom: 4 }}>IQ INSIGHT</p>
          <p style={{ fontSize: 13, color: dark ? "#a0aec0" : "#475569", lineHeight: 1.65 }}>Win rate vs Competitor A declining — deal review analysis shows pricing objection in 67% of losses. Needs battlecard update.</p>
        </div>
      </div>
    </div>
  );
}
